import { useState } from 'react'
import { Unstable_Grid2 as Grid } from '@mui/material'
import ProductCategoryList from './ProductCategoryList'
import { makeStyles } from 'tss-react/mui'
import ShowMoreLessButton from '../ShowMoreLessButton'
import { AemTopNavItem } from '@src/types/graphql-types'
import HandleMarkup from '../HandleMarkup'

const useStyles = makeStyles()((theme) => ({
  categoryList: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    '& li:first-child': {
      marginTop: theme.spacing(4),
    },
  },
  categoryTitle: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightBold,
  },
  grid: {
    borderBottom: `1px solid ${theme.palette.grey[500]}`,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: 0,
  },
  showMoreLessButton: {
    margin: '0 auto',
    marginBottom: theme.spacing(8),
    width: '100%',
  },
}))
interface ProductCategoryGroupProps {
  lists: AemTopNavItem[]
}

const ProductCategoryGroup: React.FC<ProductCategoryGroupProps> = ({
  lists,
}) => {
  const { classes } = useStyles()
  const [isExpanded, setIsExpanded] = useState(false)
  const onShowMoreToggle = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <>
      <Grid className={classes.grid} container spacing={6}>
        {lists?.map((list) => {
          if (!list || !list.title || !list.childrens) return null
          return (
            <Grid key={list.title} xs={4}>
              <h4 className={classes.categoryTitle}>
                <HandleMarkup value={list.title} />
              </h4>
              <ul className={classes.categoryList}>
                <ProductCategoryList
                  items={
                    isExpanded
                      ? (list.childrens as AemTopNavItem[])
                      : (list.childrens.slice(0, 3) as AemTopNavItem[])
                  }
                />
              </ul>
            </Grid>
          )
        })}
      </Grid>
      <ShowMoreLessButton
        expanded={isExpanded}
        setExpanded={onShowMoreToggle}
        className={classes.showMoreLessButton}
      />
    </>
  )
}

export default ProductCategoryGroup
